import moment from "moment";
import {analysisTableValueIndex} from "./utils";

export const stringProps = [
    {
        tab: 'property-information-tab',
        table: 'general-information',
        tableKey: 'property-name',
        key: 'NAME',
        fromProps: true
    },
    {
        tab: 'property-information-tab',
        table: 'general-information',
        tableKey: 'address',
        key: 'ADDRESS',
        fromProps: true
    },
    {
        tab: 'property-information-tab',
        table: 'general-information',
        tableKey: 'city',
        key: 'CITY',
        fromProps: true
    },
    {
        tab: 'property-information-tab',
        table: 'general-information',
        tableKey: 'state',
        key: 'STATE',
        fromProps: true
    },
    {
        tab: 'property-information-tab',
        table: 'general-information',
        tableKey: 'zip',
        key: 'ZIP',
        fromProps: true
    },
    {
        tab: 'property-information-tab',
        table: 'other-information',
        tableKey: 'year-built',
        key: 'YEAR_BUILT',
        fromProps: true
    },
    {
        tab: 'property-information-tab',
        table: 'general-information',
        tableKey: 'map-image',
        key: 'MAP_IMAGE'
    },
    {
        tab: 'property-information-tab',
        table: 'links',
        tableKey: 'google-maps-link',
        key: 'GOOGLE_MAPS_LINK'
    },
    {
        tab: 'property-information-tab',
        table: 'links',
        tableKey: 'tax-assessment-link-1',
        key: 'CAD_LINK_1'
    },
    {
        tab: 'property-information-tab',
        table: 'links',
        tableKey: 'tax-assessment-link-2',
        key: 'CAD_LINK_2'
    },
    {
        tab: 'property-information-tab',
        table: 'links',
        tableKey: 'tax-assessment-link-3',
        key: 'CAD_LINK_3',
    },
    {
        tab: 'property-information-tab',
        table: 'links',
        tableKey: 'tax-assessment-link-4',
        key: 'CAD_LINK_4'
    },
    {
        tab: 'pricing-tab',
        table: 'base-rent',
        tableKey: 'additional-price',
        key: 'ADDITIONAL_PRICE_TYPE',
        valueCellIndex: 0,
    },
    {
        tab: 'pricing-tab',
        table: 'exp-reimb',
        tableKey: 'annual-other-income',
        key: 'ANNUAL_OTHER_INCOME',
        valueCellIndex: 0,
    },
    {
        tab: 'current-rr-tab',
        table: 'sumed-detailed-information',
        tableKey: 'fourth-row',
        key: 'CURRENT_RR_TERM',
        valueCellIndex: 3
    },
    {
        tab: 'current-rr-tab',
        table: 'lease-notes',
        tableKey: 'lease-notes',
        key: 'CURRENT_RR_NOTES',
        valueCellIndex: 0
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'header',
        key: 'EXPENSES_CURRENT_YEAR',
        valueCellIndex: 2
    },
    {
        tab: 'expenses-tab',
        table: 'expense-notes',
        tableKey: 'expense-notes',
        key: 'EXPENSES_NOTES',
        valueCellIndex: 0
    }
];

export const dateProps = [
    {
        tab: 'pricing-tab',
        table: 'pricing-analysis',
        tableKey: 'pricing-analysis',
        key: 'ANALYSIS_DATE',
        valueCellIndex: 1,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'pricing-analysis',
        tableKey: 'pricing-analysis',
        key: 'PROFORMA_ANALYSIS_DATE',
        valueCellIndex: 2,
        forceStatic: false
    }
];

export const numberProps = [
    {
        tab: 'property-information-tab',
        table: 'other-information',
        tableKey: 'lot-size',
        key: 'LOT_SIZE'
    },
    {
        tab: 'property-information-tab',
        table: 'other-information',
        tableKey: 'current-tax-appraised-value',
        key: 'CURRENT_TAX_APPRAISED_VALUE',
        withReplace: true,
    },
    {
        tab: 'property-information-tab',
        table: 'other-information',
        tableKey: 'current-tax-liability',
        key: 'CURRENT_TAX_LIABILITY',
        withReplace: true,
    },
    {
        tab: 'pricing-tab',
        table: 'base-rent',
        tableKey: 'additional-price',
        key: 'ADDITIONAL_PRICE',
        valueCellIndex: 2,
    },
    {
        tab: 'pricing-tab',
        table: 'base-rent',
        tableKey: 'additional-price',
        key: 'PROFORMA_ADDITIONAL_PRICE',
        valueCellIndex: 6,
    },
    {
        tab: 'pricing-tab',
        table: 'total-gross-revenue',
        tableKey: 'vacancy-factor',
        key: 'VACANCY_FACTOR',
        valueCellIndex: 1,
    },
    {
        tab: 'pricing-tab',
        table: 'total-gross-revenue',
        tableKey: 'vacancy-factor',
        key: 'PROFORMA_VACANCY_FACTOR',
        valueCellIndex: 5,
    },
    {
        tab: 'pricing-tab',
        table: 'value',
        tableKey: 'cap-rate',
        key: 'CAPITALIZATION_RATE',
        valueCellIndex: 2,
        withReplace: true,
        fromProps: true,
        forceStatic: false,
    },
    {
        tab: 'pricing-tab',
        table: 'value',
        tableKey: 'cap-rate',
        key: 'PROFORMA_YIELD',
        valueCellIndex: 6,
        withReplace: true,
        forceStatic: false,
    },
    {
        tab: 'pricing-tab',
        table: 'loan-amount',
        tableKey: 'loan-amount',
        key: 'LOAN_AMOUNT',
        valueCellIndex: 2,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'loan-amount',
        tableKey: 'loan-amount',
        key: 'PROFORMA_LOAN_AMOUNT',
        valueCellIndex: 6,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'principal-balance-rate',
        tableKey: 'principal-balance',
        key: 'PRINCIPAL_BALANCE',
        valueCellIndex: 2,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'principal-balance-rate',
        tableKey: 'principal-balance',
        key: 'PROFORMA_PRINCIPAL_BALANCE',
        valueCellIndex: 6,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        key: 'DOWN_PAYMENT_PERCENT',
        valueCellIndex: 1,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        key: 'PROFORMA_DOWN_PAYMENT_PERCENT',
        valueCellIndex: 5,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        key: 'DOWN_PAYMENT',
        valueCellIndex: 2,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        key: 'PROFORMA_DOWN_PAYMENT',
        valueCellIndex: 6,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'interest-rate',
        key: 'INTEREST_RATE',
        valueCellIndex: 2,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'interest-rate',
        key: 'PROFORMA_INTEREST_RATE',
        valueCellIndex: 6,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'amortization',
        key: 'AMORTIZATION',
        valueCellIndex: 2,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'amortization',
        key: 'PROFORMA_AMORTIZATION',
        valueCellIndex: 6,
        forceStatic: false
    },
    {
        tab: 'pricing-tab',
        table: 'pricing-sensitivity-matrix-increase',
        tableKey: 'increase',
        key: 'PRICING_BPS_INCREASE',
        forceStatic: false
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'real-estate-taxes',
        key: 'CURRENT_REAL_ESTATE_TAXES',
        valueCellIndex: 2,
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'insurance',
        key: 'CURRENT_INSURANCE',
        valueCellIndex: 2,
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'non-reimbursable-expenses',
        key: 'CURRENT_NON_REIMB_EXPENSES',
        valueCellIndex: 2,
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'real-estate-taxes',
        key: 'PROFORMA_REAL_ESTATE_TAXES',
        valueCellIndex: 5,
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'insurance',
        key: 'PROFORMA_INSURANCE',
        valueCellIndex: 5,
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'non-reimbursable-expenses',
        key: 'PROFORMA_NON_REIMB_EXPENSES',
        valueCellIndex: 5,
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'current-rr-tab',
        table: 'sumed-detailed-information',
        tableKey: 'first-row',
        key: 'CURRENT_RR_END_MONTHS',
        valueCellIndex: 2
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'management-fee',
        key: 'EXPENSES_MANAGEMENT_FEE_OF_GPI',
        valueCellIndex: 2,
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'management-fee',
        key: 'PROFORMA_MGMT_FEE_OF_GPI',
        valueCellIndex: 5,
        withReplace: true,
        withToFixed: true,
    }
];

export const checkboxProps = [{
    tab: 'pricing-tab',
    table: 'pricing-analysis',
    tableKey: 'as-is-checkbox',
    key: 'AS_IS_CHECKBOX',
    valueCellIndex: 1
}, {
    tab: 'pricing-tab',
    table: 'pricing-analysis',
    tableKey: 'proforma-checkbox',
    key: 'PROFORMA_CHECKBOX',
    valueCellIndex: 1
}, {
    tab: 'pricing-tab',
    table: 'pricing-analysis',
    tableKey: 'assumable-loan-checkbox',
    key: 'ASSUMABLE_LOAN_CHECKBOX',
    valueCellIndex: 1
}]

export const tenantFields = [
    {
        tab: 'current-rr-tab',
        table: 'general-information',
        key: 'RR_SUITE_CODE',
        type: 'string',
        valueCellIndex: 0,
    },
    {
        tab: 'current-rr-tab',
        table: 'general-information',
        key: 'TENANT_NAME',
        type: 'string',
        valueCellIndex: 1,
    },
    {
        tab: 'current-rr-tab',
        table: 'general-information',
        key: 'RR_SQFT',
        type: 'number',
        valueCellIndex: 2,
        withReplace: true,
    },
    {
        tab: 'current-rr-tab',
        table: 'general-information',
        key: 'ARCIMEDES_ROW_ID',
        type: 'string',
        valueCellIndex: 3,
    },
    {
        tab: 'current-rr-tab',
        table: 'general-information',
        key: 'TENANT_ROW_ID',
        type: 'string',
        valueCellIndex: 4,
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_START_DATE',
        valueCellIndex: 1,
        type: 'date',
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_END_DATE',
        valueCellIndex: 2,
        type: 'date',
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_MONTHLY_RENT',
        valueCellIndex: 3,
        type: 'number',
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_ESCALATION_DATE',
        valueCellIndex: 10,
        type: 'date',
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_ESCALATION_MONTHLY_RENT',
        valueCellIndex: 11,
        type: 'number',
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_OPTIONS',
        type: 'string',
        valueCellIndex: 15,
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_OPTION_1_RENT',
        type: 'string',
        valueCellIndex: 16,
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_OPTION_2_RENT',
        type: 'string',
        valueCellIndex: 17,
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_OPTION_3_RENT',
        type: 'string',
        valueCellIndex: 18,
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_OPTION_4_RENT',
        type: 'string',
        valueCellIndex: 19,
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_OPTION_5_RENT',
        type: 'string',
        valueCellIndex: 20,
    },
    {
        tab: 'current-rr-tab',
        table: 'detailed-information',
        key: 'RR_NOTES',
        type: 'string',
        valueCellIndex: 21,
    },
    {
        tab: 'proforma-rr-tab',
        table: 'general-information',
        key: 'PROFORMA_RR_TENANT_NAME',
        type: 'string',
        valueCellIndex: 1,
    },
    {
        tab: 'proforma-rr-tab',
        table: 'general-information',
        key: 'PROFORMA_RR_SQFT',
        type: 'number',
        valueCellIndex: 2,
        withReplace: true,
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        key: 'PROFORMA_RR_START_DATE',
        valueCellIndex: 1,
        type: 'date',
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        key: 'PROFORMA_RR_END_DATE',
        valueCellIndex: 2,
        type: 'date',
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        key: 'PROFORMA_RR_PSF',
        valueCellIndex: 5,
        type: 'number',
        withToFixed: true,
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        key: 'PROFORMA_TI_SF',
        valueCellIndex: 6,
        type: 'number',
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        key: 'PROFORMA_LC',
        valueCellIndex: 7,
        type: 'number',
        withToFixed: true,
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'detailed-information',
        key: 'REIMB_CODE',
        valueCellIndex: 2,
        type: 'number',
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'detailed-information',
        key: 'REIMB_ANNUAL_OTHER',
        valueCellIndex: 11,
        type: 'number',
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'detailed-information',
        key: 'REIMB_NOTES',
        type: 'string',
        valueCellIndex: 15,
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'detailed-information',
        key: 'REIMB_ANNUAL_OTHER_1',
        valueCellIndex: 23,
        type: 'number',
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'detailed-information',
        key: 'REIMB_MONTHLY_RET',
        valueCellIndex: 28,
        type: 'number',
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'detailed-information',
        key: 'REIMB_MONTHLY_INS',
        valueCellIndex: 30,
        type: 'number',
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'detailed-information',
        key: 'REIMB_MONTHLY_CAM',
        valueCellIndex: 32,
        type: 'number',
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'detailed-information',
        key: 'REIMB_MONTHLY_OTHER',
        valueCellIndex: 34,
        type: 'number',
        withReplace: true,
        withToFixed: true,
    },
    {
        tab: 'proforma-reimbursement-tab',
        table: 'detailed-information',
        key: 'PROFORMA_REIMB_CODE',
        valueCellIndex: 2,
        type: 'number',
    },
];

export const tenantTypeFields = [
    {
        key: 'REIMB_TYPES_DESCRIPTION',
        valueCellIndex: 1,
        type: 'string',
    },
    {
        key: 'REIMB_TYPES_CAM_INCREASE',
        valueCellIndex: 2,
        type: 'number',
    },
    {
        key: 'REIMB_TYPES_HAS_CAM',
        valueCellIndex: 3,
        type: 'checkbox',
    },
    {
        key: 'REIMB_TYPES_CAM_VALUE',
        valueCellIndex: 4,
        type: 'number',
    },
    {
        key: 'REIMB_TYPES_HAS_MANAGEMENT_FEE',
        valueCellIndex: 5,
        type: 'checkbox',
    },
    {
        key: 'REIMB_TYPES_MGMT_FEE_VALUE',
        valueCellIndex: 6,
        type: 'number',
    },
    {
        key: 'REIMB_TYPES_HAS_INSURANCE',
        valueCellIndex: 7,
        type: 'checkbox',
    },
    {
        key: 'REIMB_TYPES_INSURANCE_VALUE',
        valueCellIndex: 8,
        type: 'number',
    },
    {
        key: 'REIMB_TYPES_HAS_TAXES',
        valueCellIndex: 9,
        type: 'checkbox',
    },
    {
        key: 'REIMB_TYPES_TAXES_VALUE',
        valueCellIndex: 10,
        type: 'number',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_DESCRIPTION',
        valueCellIndex: 1,
        type: 'string',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_CAM_INCREASE',
        valueCellIndex: 2,
        type: 'number',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_HAS_CAM',
        valueCellIndex: 3,
        type: 'checkbox',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_CAM_VALUE',
        valueCellIndex: 4,
        type: 'number',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_HAS_MANAGEMENT_FEE',
        valueCellIndex: 5,
        type: 'checkbox',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_MGMT_FEE_VALUE',
        valueCellIndex: 6,
        type: 'number',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_HAS_INSURANCE',
        valueCellIndex: 7,
        type: 'checkbox',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_INSURANCE_VALUE',
        valueCellIndex: 8,
        type: 'number',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_HAS_TAXES',
        valueCellIndex: 9,
        type: 'checkbox',
    },
    {
        key: 'PRO_FORMA_REIMB_TYPES_TAXES_VALUE',
        valueCellIndex: 10,
        type: 'number',
    },
];

export const pricingChanges = [
    {
        tab: 'pricing-tab',
        table: 'value',
        tableKey: 'cap-rate',
        valueCellIndex: 2,
        property: 'editable',
        getValue(isProformaPricingType) {
            return !isProformaPricingType;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'value',
        tableKey: 'cap-rate',
        valueCellIndex: 6,
        property: 'editable',
        getValue(isProformaPricingType) {
            return isProformaPricingType;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'interest-rate',
        valueCellIndex: 2,
        property: 'editable',
        getValue(isProformaPricingType) {
            return !isProformaPricingType;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'interest-rate',
        valueCellIndex: 6,
        property: 'editable',
        getValue(isProformaPricingType) {
            return isProformaPricingType;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'principal-balance-rate',
        tableKey: 'principal-balance',
        valueCellIndex: 6,
        property: 'editable',
        getValue(isProformaPricingType, isAssumableLoan) {
            return isAssumableLoan;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        valueCellIndex: 1,
        property: 'editable',
        getValue(isProformaPricingType, isAssumableLoan) {
            return !isProformaPricingType && !isAssumableLoan;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        valueCellIndex: 5,
        property: 'editable',
        getValue(isProformaPricingType, isAssumableLoan) {
            return isProformaPricingType && !isAssumableLoan;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        valueCellIndex: 6,
        property: 'editable',
        getValue(isProformaPricingType, isAssumableLoan) {
            return isAssumableLoan;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        valueCellIndex: 2,
        property: 'editable',
        getValue(isProformaPricingType, isAssumableLoan) {
            return isAssumableLoan;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'loan-amount',
        tableKey: 'loan-amount',
        valueCellIndex: 2,
        property: 'editable',
        getValue(isProformaPricingType, isAssumableLoan) {
            return isAssumableLoan;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'principal-balance-rate',
        tableKey: 'principal-balance',
        valueCellIndex: 2,
        property: 'editable',
        getValue(isProformaPricingType, isAssumableLoan) {
            return isAssumableLoan;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'loan-amount',
        tableKey: 'loan-amount',
        valueCellIndex: 6,
        property: 'editable',
        getValue(isProformaPricingType, isAssumableLoan) {
            return isAssumableLoan;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'amortization',
        valueCellIndex: 2,
        property: 'editable',
        getValue(isProformaPricingType) {
            return !isProformaPricingType;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'amortization',
        valueCellIndex: 6,
        property: 'editable',
        getValue(isProformaPricingType) {
            return isProformaPricingType;
        }
    },
    {
        tab: 'marketing-tab',
        table: 'offering-summary',
        tableKey: 'cap-rate',
        property: 'name',
        getValue(isProformaPricingType) {
            return isProformaPricingType ? 'Cap Rate (As Is)' : 'Cap Rate';
        }
    },
    {
        tab: 'marketing-tab',
        table: 'offering-summary',
        tableKey: 'net-operating-income',
        property: 'name',
        getValue(isProformaPricingType) {
            return isProformaPricingType ? 'Net Operating Income (As Is)' : 'Net Operating Income';
        }
    },
    {
        tab: 'marketing-tab',
        table: 'offering-summary',
        tableKey: 'proforma-cap-rate',
        property: 'hidden',
        getValue(isProformaPricingType) {
            return !isProformaPricingType;
        }
    },
    {
        tab: 'marketing-tab',
        table: 'offering-summary',
        tableKey: 'net-operating-income-proforma',
        property: 'hidden',
        getValue(isProformaNetOperatingIncome) {
            return !isProformaNetOperatingIncome;
        }
    }
];

export const defaultValues = [
    {
        tab: 'pricing-tab',
        table: 'exp-reimb',
        tableKey: 'annual-other-income',
        key: 'ANNUAL_OTHER_INCOME',
        valueCellIndex: 0,
        getDefaultValue() {
            return 'Annual Other Income';
        }
    },
    {
        tab: 'pricing-tab',
        table: 'pricing-analysis',
        tableKey: 'as-is-checkbox',
        valueCellIndex: 1,
        getDefaultValue() {
            return true;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        valueCellIndex: 1,
        getDefaultValue() {
            return 30;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'down-payment',
        tableKey: 'down-payment',
        valueCellIndex: 5,
        getDefaultValue() {
            return 30;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'interest-rate',
        valueCellIndex: 2,
        getDefaultValue() {
            return 4.25;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'interest-rate',
        valueCellIndex: 6,
        getDefaultValue() {
            return 4.25;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'amortization',
        valueCellIndex: 2,
        getDefaultValue() {
            return 25;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'interest-rate',
        tableKey: 'amortization',
        valueCellIndex: 6,
        getDefaultValue() {
            return 25;
        }
    },
    {
        tab: 'pricing-tab',
        table: 'pricing-sensitivity-matrix-increase',
        tableKey: 'increase',
        getDefaultValue() {
            return 0.25;
        }
    },
    {
        tab: 'current-rr-tab',
        table: 'sumed-detailed-information',
        tableKey: 'first-row',
        valueCellIndex: 2,
        getDefaultValue() {
            return 12;
        }
    },
    {
        tab: 'current-rr-tab',
        table: 'sumed-detailed-information',
        tableKey: 'fourth-row',
        valueCellIndex: 3,
        getDefaultValue() {
            return 'Ave Remaining Term';
        }
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        valueCellIndex: 1,
        getDefaultValue({tabs, index, withoutCondition}) {
            // analysis date (just for 'Lease Up' tenants)
            const inputText = tabs['current-rr-tab'].tables['general-information'].rows[index].valueCells[1].value;
            if (inputText.trim() !== 'Vacant' && inputText.trim() !== 'vacant' && !withoutCondition) return;
            return tabs['pricing-tab'].tables['pricing-analysis'].rows['pricing-analysis'].valueCells[1].value;
        }
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        valueCellIndex: 2,
        getDefaultValue({tabs, index, withoutCondition}) {
            // analysis date + 5 years - 1 day (just for 'Lease Up' tenants)
            const inputText = tabs['current-rr-tab'].tables['general-information'].rows[index].valueCells[1].value;
            if (inputText.trim() !== 'Vacant' && inputText.trim() !== 'vacant' && !withoutCondition) return;

            const analysisDate = tabs['pricing-tab'].tables['pricing-analysis'].rows['pricing-analysis'].valueCells[1].value;
            if (!analysisDate) return '';
            const date = moment(analysisDate).add(5, 'years').subtract(1, 'days');
            return date.format('MM/DD/YYYY');
        }
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        valueCellIndex: 5,
        getDefaultValue({tabs, index, precomputedValues}) {
            let psf = tabs['proforma-rr-tab'].tables['detailed-information'].rows[index].valueCells[5].value;
            if (psf)
                return psf;
            psf = tabs['current-rr-tab'].tables['detailed-information'].rows[index].valueCells[5].getComputedValue(tabs, index, precomputedValues).internalValue;
            return psf > 0 ? psf : null;
        }
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        valueCellIndex: 6,
        getDefaultValue({tabs, index, withoutCondition}) {
            const inputText = tabs['current-rr-tab'].tables['general-information'].rows[index].valueCells[1].value;
            if (inputText.trim() !== 'Vacant' && inputText.trim() !== 'vacant' && !withoutCondition) return;
            return '25.00';
        }
    },
    {
        tab: 'proforma-rr-tab',
        table: 'detailed-information',
        valueCellIndex: 7,
        getDefaultValue({tabs, index, withoutCondition}) {
            const inputText = tabs['current-rr-tab'].tables['general-information'].rows[index].valueCells[1].value;
            if (inputText.trim() !== 'Vacant' && inputText.trim() !== 'vacant' && !withoutCondition) return;
            return '6.00';
        }
    },
    {
        tab: 'expenses-tab',
        table: 'expenses',
        tableKey: 'header',
        valueCellIndex: 2,
        getDefaultValue({tabs}) {
            return getExpensesHeader({tabs});
        }
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 1,
        getDefaultValue({index}) {
            return getDefaultTenantType(index);
        }
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 2,
        getDefaultValue({index}) {
            return getDefaultAdminFee(index);
        }
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 3,
        getDefaultValue({index}) {
            return getDefaultCheckboxesCAM(index);
        }
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 5,
        getDefaultValue({index}) {
            return getDefaultCheckboxesMgmt(index);
        }
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 7,
        getDefaultValue({index}) {
            return getDefaultCheckboxes(index);
        }
    },
    {
        tab: 'current-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 9,
        getDefaultValue({index}) {
            return getDefaultCheckboxes(index);
        }
    },
    {
        tab: 'proforma-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 1,
        getDefaultValue({index}) {
            return getDefaultTenantType(index);
        }
    },
    {
        tab: 'proforma-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 2,
        getDefaultValue({index}) {
            return getDefaultAdminFee(index);
        }
    },
    {
        tab: 'proforma-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 3,
        getDefaultValue({index}) {
            return getDefaultCheckboxesCAM(index);
        }
    },
    {
        tab: 'proforma-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 5,
        getDefaultValue({index}) {
            return getDefaultCheckboxesMgmt(index);
        }
    },
    {
        tab: 'proforma-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 7,
        getDefaultValue({index}) {
            return getDefaultCheckboxes(index);
        }
    },
    {
        tab: 'proforma-reimbursement-tab',
        table: 'reimbursement-types',
        valueCellIndex: 9,
        getDefaultValue({index}) {
            return getDefaultCheckboxes(index);
        }
    }
];

function getDefaultTenantType(index) {
    switch (index) {
        case 0: {
            return 'NNN';
        }
        case 1: {
            return 'NNN (Excl MGMT)';
        }
        case 2: {
            return 'NNN+5%AF (Excl MGMT)';
        }
        case 3: {
            return 'NNN+10%AF (Excl MGMT)';
        }
        case 4: {
            return 'NNN+15%AF (Excl MGMT)';
        }
        case 5: {
            return 'NN';
        }
        case 6: {
            return 'Gross';
        }
        default: {
            return '';
        }
    }
}

function getDefaultAdminFee(index) {
    switch (index) {
        case 2: {
            return 5;
        }
        case 3: {
            return 10;
        }
        case 4: {
            return 15;
        }
        default: {
            return '';
        }
    }
}

function getDefaultCheckboxes(index) {
    switch (index) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            return true;
        default:
            return false;
    }
}

function getDefaultCheckboxesCAM(index) {
    switch (index) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return true;
        default:
            return false;
    }
}

function getDefaultCheckboxesMgmt(index) {
    switch (index) {
        case 0:
        case 2:
        case 3:
        case 4: {
            return true;
        }
        default: {
            return false;
        }
    }
}

export function getExpensesHeader({tabs, pricingAnalysis}) {
    const analysisDate = pricingAnalysis ? pricingAnalysis : tabs['pricing-tab'].tables['pricing-analysis'].rows['pricing-analysis'].valueCells[analysisTableValueIndex].value;
    const date = new Date(analysisDate);
    const year = new Date().getFullYear();

    if (date && !isNaN(date.getTime())) {
        const analysisDateYear = date && date.getFullYear() ? date.getFullYear() - 1 : year;
        return `Current (${analysisDateYear})`;
    }
    return `Current (${year})`;
}
